module.exports = __webpack_public_path__ + "img/Flaticon2.74a2255.svg";